// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2DDeY","footer":"ModalInfo_footer__3TMxY"};